<template>
    <b-upload
        multiple
        v-bind="$attrs"
        v-model="files"
        :loading="isLoading"
        :disabled="disabled"
        @input="input"
        drag-drop>
        <section class="section">
            <div class="content has-text-centered">
                <p>
                    <b-icon
                        icon="paperclip"
                        size="is-medium">
                    </b-icon>
                </p>
                <p>
                    <span>Прикрепить файлы</span>
                    <span v-if="maxSize > 0" class="has-text-grey-light">
                        <br>
                        не более {{ readableMaxSize }}
                    </span>
                </p>
            </div>
        </section>
    </b-upload>
</template>

<script>
import toasts from "../mixins/toasts";

export default Vue.extend({
  props: {
    model: {
      type: Object,
      required: false
    },
    maxSize: {
      type: Number
    },
    disabled: {
      type: Boolean
    }
  },
  mixins: [toasts],
  data() {
    return {
      isLoading: false,
      files: []
    };
  },
  computed: {
    readableMaxSize() {
      let suffixes = [
        this.$t("attachments.suffixes.kb"),
        this.$t("attachments.suffixes.mb"),
        this.$t("attachments.suffixes.gb")
      ];
      let suffix = suffixes.shift();
      let size = _.clone(this.maxSize);

      while (size >= 1024 && suffixes.length > 0) {
        size /= 1024;
        suffix = suffixes.shift();
      }
      return `${size} ${suffix}`;
    }
  },
  methods: {
    input(files) {
      if (!this.model) {
        this.$emit("change", files);
        return;
      }

      let uploads = [];

      let delay = 0;

      for (let file of files) {
        uploads.push(this.upload(file, delay));
        delay += 500;
      }

      Promise.all(uploads)
        .then(_ => {
          this.toast("success", "Все файлы были успешно загружены");
        })
        .catch(error => {
          switch (error.response.status) {
            case 403: {
              switch (error.response.data.error) {
                case "storage space limit reached": {
                  this.toast("error", "Недостаточно свободного места");
                  break;
                }
                case "attachment limit reached": {
                  this.toast(
                    "error",
                    "Достигнуто максимальное число прикреплений"
                  );
                  break;
                }
                case "file size limit reached": {
                  this.toast("error", "Объем файла слишком большой");
                  break;
                }
                default: {
                  this.toast("error", "@unexpected", error);
                }
              }
              break;
            }
            case 429: {
              this.toast(
                "error",
                "Не удалось загрузить файл в настоящий момент"
              );
              break;
            }
            default: {
              this.toast("error", "@unexpected", error);
            }
          }
        })
        .finally(_ => {
          this.files.splice(0, this.files.length);
          this.isLoading = false;
          this.$emit("done");
        });
    },
    upload(file, delay) {
      return new Promise((resolve, reject) => {
        // maxSize is in kilobytes
        if (this.maxSize && file.size / 1024 > this.maxSize) {
          reject({
            response: {
              status: 403,
              data: {
                error: "file size limit reached"
              }
            }
          });
        }

        this.isLoading = true;

        let data = new FormData();
        data.append("model_id", this.model.id);
        data.append("model_type", this.model.type);
        data.append("title", file.name.replace(/\.[^/.]+$/, ""));
        data.append("file", file);

        this.$_.delay(_ => {
          if (this.isLoading) {
            axios
              .post(`/api/attachments`, data)
              .then(response => {
                resolve(response);
                this.$emit("uploaded", response.data);
              })
              .catch(error => {
                reject(error);
              });
          } else {
            resolve();
          }
        }, delay);
      });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/attachments/Upload.vue